export default {
    sim_provider_account_create_title: "Crear cuenta de proveedor SIM",
    sim_provider_account_same_name_exits: "Ya existe una cuenta de proveedor SIM con el mismo nombre",
    sim_provider_account_create_success_message: "Se ha creado la cuenta de proveedor SIM",
    sim_provider_account_edit_title: "Editar cuenta de proveedor SIM",
    sim_provider_account_edit_success_message: "La cuenta del proveedor SIM ha sido editada",
    sim_provider_account_name: "Nombre de la Cuenta",

    sim_provider_account_sim_provider: "Proveedor de SIM",
    sim_provider_account_sim_type: "Tipo de SIM",
    sim_provider_account_username: "Usuario",
    sim_provider_account_password: "Contraseña",
}